import axios from 'axios';
import { AxiosError } from 'axios';
import { processAxiosError } from '../../utils/AxiosInterceptors/ErrorInterceptor';
import { CommonResult, OK, SERVICE_TEMPORARILY_UNAVAILABLE } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const URL = `${endpoint}/mail/stop`;

export interface MailStopApiResponse {
  result: CommonResult;
  hit: number;
}

export interface MailStopApiRequest {
  customerId: number;
  token: string;
}

/**
 * メール配信停止前処理API
 * @param request リクエスト
 */
export async function getMailStopApi(request: MailStopApiRequest): Promise<MailStopApiResponse> {
  try {
    const response = await axios.get(`${URL}?customerId=${request.customerId}&token=${request.token}`);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      case SERVICE_TEMPORARILY_UNAVAILABLE.status:
        return data;
      default:
        throw new Error();
    }
  } catch (error) {
    const errorResponse = processAxiosError(error as AxiosError);
    return {
      ...errorResponse.data,
      hit: 0,
    };
  }
}
